import 'nouislider';

const numberDecimals = WCBT_GLOBAL_OBJECT.decimals || 0;
const thousandsSeparator = WCBT_GLOBAL_OBJECT.thousand_separator || '';

const wcbtPrice = () => {
	const priceWrapper = document.querySelector( '.wcbt-product-filter .price.wrapper' );

	if ( ! priceWrapper ) {
		return;
	}

	const minPrice = priceWrapper.getAttribute( 'data-min' );
	const maxPrice = priceWrapper.getAttribute( 'data-max' );
	let step = priceWrapper.getAttribute( 'data-step' );

	if ( minPrice === '' || maxPrice === '' || step === '' ) {
		return;
	}

	const minPriceNode = priceWrapper.querySelector( 'input[name="min-price"]' );
	const maxPriceNode = priceWrapper.querySelector( 'input[name="max-price"]' );

	const priceSliderNode = priceWrapper.querySelector( '#search-price' );
	const start = minPriceNode.value || minPrice;
	const end = maxPriceNode.value || maxPrice;
	step = parseInt( step );

	noUiSlider.create( priceSliderNode, {
		start: [ parseInt( start ), parseInt( end ) ],
		connect: true,
		step,
		tooltips: false,
		margin: 30,
		range: {
			min: parseInt( minPrice ), max: parseInt( maxPrice ),
		},
		// direction: 'lt',
	} );

	priceSliderNode.noUiSlider.on( 'update', function( values, handle, unencoded ) {
		minPriceNode.value = parseInt( values[ 0 ] );
		maxPriceNode.value = parseInt( values[ 1 ] );
		if ( [ 'left', 'left-space' ].includes( WCBT_GLOBAL_OBJECT.price_format ) ) {
			priceWrapper.querySelector( '.min bdi' ).lastChild.data = renderPriceNumber( values[ 0 ] );
			priceWrapper.querySelector( '.max bdi' ).lastChild.data = renderPriceNumber( values[ 1 ] );
		} else {
			priceWrapper.querySelector( '.min bdi' ).firstChild.data = renderPriceNumber( values[ 0 ] );
			priceWrapper.querySelector( '.max bdi' ).firstChild.data = renderPriceNumber( values[ 1 ] );
		}
	} );

	//Reset
	const resetBtn = priceWrapper.querySelector( '.reset' );

	if ( resetBtn ) {
		resetBtn.addEventListener( 'click', function( event ) {
			event.preventDefault();
			priceSliderNode.noUiSlider.updateOptions( {
				start: [ parseInt( start ), parseInt( end ) ],
			} );
		} );
	}
};

const renderPriceNumber = ( price ) => {
	price = ( price / 1 ).toFixed( numberDecimals );
	price = price.toString().replace( /\B(?=(\d{3})+(?!\d))/g, thousandsSeparator );

	if ( WCBT_GLOBAL_OBJECT.price_format === 'left-space' ) {
		price = ' ' + price;
	} else if ( WCBT_GLOBAL_OBJECT.price_format === 'right-space' ) {
		price = price + ' ';
	}

	return price;
};

const renderPriceFormat = ( price ) => {
	price = renderPriceNumber( price );

	if ( [ 'left', 'left-space' ].includes( WCBT_GLOBAL_OBJECT.price_format ) ) {
		price = WCBT_GLOBAL_OBJECT.currency_symbol + price;
	} else {
		price = price + WCBT_GLOBAL_OBJECT.currency_symbol;
	}

	return price;
};

export { renderPriceFormat };
export default wcbtPrice;
